import React, { useContext, useEffect, useState } from 'react';
import { useProperty } from '@spotify-internal/remote-config-integration-react';
import { FooterProps, HeaderProps } from '@spotify-internal/masthead-react';

import { getMasthead } from 'utils/masthead/masthead';
import { simplifiedMasthead } from 'utils/remote-config/properties';

import { MarketContext } from './market';
import { useVerticalConfig } from './vertical';

interface MastheadProviderProps {
  isPlain: boolean;
}

interface MastheadData {
  header?: HeaderProps;
  footer?: FooterProps;
}

const MastheadContext = React.createContext<MastheadData>({});

export function useMastheadData() {
  return useContext(MastheadContext);
}

const MastheadProvider: React.FC<MastheadProviderProps> = ({ children, isPlain }) => {
  const { marketCode } = useContext(MarketContext);
  const useSimplifiedMasthead = useProperty(simplifiedMasthead, { loadingValue: null });
  const {
    features: { configureMasthead },
  } = useVerticalConfig();

  const [header, setHeader] = useState<HeaderProps>();
  const [footer, setFooter] = useState<FooterProps>();

  useEffect(() => {
    const getMastheadData = async (simplifyMasthead: boolean) => {
      const res = await getMasthead(marketCode, simplifyMasthead);
      setFooter(res.footer);
      setHeader(res.header);
    };
    if (!configureMasthead && !isPlain && useSimplifiedMasthead !== null) {
      getMastheadData(!!useSimplifiedMasthead);
    }
  }, [marketCode, isPlain, useSimplifiedMasthead, configureMasthead]);

  return <MastheadContext.Provider value={{ header, footer }}>{children}</MastheadContext.Provider>;
};

export default MastheadProvider;
